// extracted by mini-css-extract-plugin
export default {"about":"about_about__MxROy","textContainer":"about_textContainer__WFWWf","title":"about_title__o7OQW","imageBorder":"about_imageBorder__fUPNr"};